export default __webpack_public_path__ + "static/media/rechterbalk_banner_v_3.0.7ba5e126.png";